/**
 * 外部サービス連携 管理項目
 */
import * as types from '../../mutation-types/driver-types'

const getDefaultState = () => {
  return {
    /**
     * state
     * @type {String | null}
     */
    state: null,
  }
}

const providerSetting = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    isConfigured: ( state ) => {
      return (state.state != null)
    },
  },
  actions: {
    release ({ commit }) {
      commit(types.DRIVER_PROVIDER_SETTING_RELEASE)
    },
    reflection ({ commit }, { params }) {
      commit(types.DRIVER_PROVIDER_SETTING_REFLECTION, { content: params })
    }
  },
  mutations: {
    [types.DRIVER_PROVIDER_SETTING_RELEASE] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_PROVIDER_SETTING_REFLECTION] (state, { content }) {
      state.state = content.state
    },
  },
}

export default providerSetting
